<template>
      <v-data-table :headers="headers1" :items="ensayo.mensaje_set" sort-by="calories">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Listado de mensajes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="![1,2].some(r => usuario.groups.includes(r))"
                  color="primary"
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                ><v-icon dark left>mdi-plus</v-icon>Nuevo mensaje</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Nuevo mensaje</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.text" label="Texto"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.showtime" label="Tiempo para mostrar (seg)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.time" label="Duración (seg)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.waitingroom"
                          :items="items"
                          label="Sala de Espera"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.soundactivate"
                          :items="items"
                          label="Sonido activado"
                        ></v-select>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.id="{ item }">
          {{item.id}}
        </template>
        <template v-slot:item.textoMensaje="{ item }">
          <span v-if="item.isEditing===false">{{item.textoMensaje}}</span>
          <v-text-field v-else class="pa-0 short-tf" v-model="item.textoMensaje" hide-details single-line dense></v-text-field>
        </template>
        <template v-slot:item.tiempoMostrar="{ item }">
          <span v-if="item.isEditing===false">{{item.tiempoMostrar}}</span>
          <v-text-field v-else class="pa-0 short-tf" v-model="item.tiempoMostrar" hide-details single-line dense></v-text-field>
        </template>
        <template v-slot:item.duracion="{ item }">
          <span v-if="item.isEditing===false">{{item.duracion}}</span>
          <v-text-field v-else class="pa-0 short-tf" v-model="item.duracion" hide-details single-line dense></v-text-field>
        </template>

        <template v-slot:item.neutral="{ item }">
          <span v-if="item.isEditing===false">{{item.neutral}}</span>
          <v-select
            v-else
            v-model="item.neutral"
            :items="items"
            class="pa-0 short-tf"
            hide-details 
            single-line
            dense
          ></v-select>
        </template>

        <template v-slot:item.sonidoActivado="{ item }">
          <span v-if="item.isEditing===false">{{item.sonidoActivado}}</span>
          <v-select
            v-else
            v-model="item.sonidoActivado"
            :items="items"
            class="pa-0 short-tf"
            hide-details 
            single-line
            dense
          ></v-select>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-container v-if="item.isEditing===false">
            <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
          </v-container>
          <v-container v-else>
            <v-icon small class="mr-2" @click="update(item)">mdi-check</v-icon>
            <v-icon small class="mr-2" @click="cancel(item)">mdi-close</v-icon>
          </v-container>
        </template>
        <template v-slot:no-data>
          No hay datos
        </template>
        </v-data-table>

</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      items: [true, false],
      headers1: [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        { text: 'Texto', value: 'textoMensaje' },
        { text: 'Tiempo mostrar', value: 'tiempoMostrar' },
        { text: 'Duración', value: 'duracion' },
        { text: 'Sala de Espera', value: 'neutral' },
        { text: 'Sonido Activado', value: 'sonidoActivado' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      desserts1: [],
      editedIndex: -1,
      editedItem: {
        text: '',
        showtime: undefined,
        time: undefined,
        waitingroom: undefined,
        soundactivate: undefined,
      },
      defaultItem: {
        text: '',
        showtime: undefined,
        time: undefined,
        waitingroom: undefined,
        soundactivate: undefined,
      },
    }),

    computed: {
      ensayo() {
        return this.$store.state.ensayo
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {
        this.desserts = [
          {
            id: 1,
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
          },
          {
            id: 2,
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
          },
        ]
      },

      editItem (item) {
        var editedIndex = this.ensayo.mensaje_set.indexOf(item)
        item = Object.assign({}, item)
        item.isEditing = true;
        item.preText = item.textoMensaje;
        item.preShowtime = item.tiempoMostrar;
        item.preTime = item.duracion;
        item.preWaitingroom = item.neutral;
        item.preSoundactivate = item.sonidoActivado;
        console.log(item);
        Object.assign(this.ensayo.mensaje_set[editedIndex], item)
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('deleteMensaje', {
          'id': this.ensayo.id,
          'item': item
        });
      },

      save () {
        this.$store.dispatch('createMensaje', {
          'id': this.ensayo.id,
          'item': this.editedItem
        });
        this.close()
      },

      update (item) {
        item.isEditing = false;
        var editedIndex = this.ensayo.mensaje_set.indexOf(item)
        Object.assign(this.ensayo.mensaje_set[editedIndex], item)
        this.$store.dispatch('editMensaje', {
          'id': this.ensayo.id, 
          'item': item
        });
      },

      cancel (item) {
        item.isEditing = false;
        item.textoMensaje = item.preText;
        item.tiempoMostrar = item.preShowtime;
        item.duracion = item.preTime;
        item.neutral = item.preWaitingroom;
        item.sonidoActivado = item.preSoundactivate;

        var editedIndex = this.ensayo.mensaje_set.indexOf(item)
        Object.assign(this.ensayo.mensaje_set[editedIndex], item)
      }
    },
  }
</script>

<style scoped>
  .short-tf {
    width: 50px;
  }
</style>
